import { useQuery } from '@apollo/client'
import { useParams } from 'react-router'
import { format } from '@/utils'
import { parseISO } from 'date-fns'
import { useTranslate } from '@ur-solutions/react-hooks'
import { TACHO_DRIVER_FILE_QUERY } from '../queries'
import { formatTachoFileSource } from '../consts'
import { TachoFileBrowser } from '../components/tacho-file-browser/tacho-file-browser'

const ARCHIVE_PATH = '/analytics/file-archive'

export const TachoDriverFileBrowser: React.FC = () => {
  const translations = useTranslate({
    user: 'common.user',
    source: 'common.source',
    uploadedAt: 'common.date',
  })

  const { fileId } = useParams()

  const { data, loading } = useQuery(TACHO_DRIVER_FILE_QUERY, {
    variables: { id: fileId ?? '' },
    skip: !fileId,
  })

  const file = data?.tachoDriverFile

  return (
    <TachoFileBrowser
      fileName={file?.fileName}
      processedValue={file?.processedValue}
      loading={loading}
      backPath={ARCHIVE_PATH}
      meta={[
        {
          label: translations.user,
          value: file?.user?.fullName || file?.driverCardNumber,
        },
        {
          label: translations.source,
          value: file?.source ? formatTachoFileSource(file.source) : null,
        },
        {
          label: translations.uploadedAt,
          value: file
            ? format(parseISO(file.createdAt), 'dd. MMM yyyy HH:mm')
            : null,
        },
      ]}
    />
  )
}
